import { render, staticRenderFns } from "./billFlush.vue?vue&type=template&id=70dba2b4&scoped=true"
import script from "./billFlush.vue?vue&type=script&lang=js"
export * from "./billFlush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dba2b4",
  null
  
)

export default component.exports